import ListCertifications from "@/views/organization/certifications/query_formats/ListCertifications.vue";
import ListFormats from "@/views/organization/certifications/query_formats/ListFormats.vue";
import ListProducers from "@/views/organization/certifications/query_formats/ListProducers.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "org",
  role: "certifications",
  permission: "query_formats"
});

export default [
  {
    path: "/org/:organization_id/certifications/query_formats",
    name: routeName(""),
    props: true,
    redirect: { name: routeName("list_certifications") }
  },
  {
    path: "/org/:organization_id/certifications/query_formats/list_certifications",
    name: routeName("list_certifications"),
    component: ListCertifications,
    props: true,
    meta: META
  },
  {
    path: "/org/:organizationId/certifications/query_formats/list_formats/:certificationId/:certificationVersionId",
    name: routeName("list_formats"),
    component: ListFormats,
    props: true,
    meta: META
  },
  {
    path: "/org/:organizationId/certifications/query_formats/list_producers/:certificationId/:certificationVersionId/:formatCertificationId",
    name: routeName("list_producers"),
    component: ListProducers,
    props: true,
    meta: META
  },
];
